import { getEntityById } from 'api/bitedb/entities/entities.service';

type EntityFetcher = (
  id?: string,
  databaseId?: string,
  selectedTeamId?: string,
) => Promise<any>;

/**
 * The record as the Verification Run just saved it. Tries the database-scoped
 * read first (exact association), then, if that association is not found, the
 * read the verification page itself uses. Never returns the copy loaded before
 * the run: a report built from it would show the previous results.
 */
export const loadSavedRecord = async (
  supplier:
    | { id?: unknown; entity_id?: unknown; database_id?: unknown }
    | null
    | undefined,
  teamId: string | undefined,
  fetchEntity: EntityFetcher = getEntityById,
): Promise<any> => {
  const entityId = String(supplier?.id || supplier?.entity_id || '');
  if (!entityId) throw new Error('The record has no entity id');
  const databaseId = supplier?.database_id
    ? String(supplier.database_id)
    : undefined;

  if (databaseId && teamId) {
    // Only a missing association falls back; any other failure would make
    // the report from a record we cannot vouch for.
    try {
      const scoped = await fetchEntity(entityId, databaseId, teamId);
      if (scoped) return scoped;
    } catch (error) {
      if ((error as any)?.response?.status !== 404) throw error;
    }
  }
  const record = await fetchEntity(entityId, undefined, teamId);
  if (!record) throw new Error('The saved record could not be loaded');
  return record;
};
